import React from 'react';

import styles from './highlightedMentionsStyles.scss';

const HighlightedMentions: React.FC = (): React.ReactElement => {
  return <div className={styles.highlightedMentions}>This report mentions this company</div>;
};

export default HighlightedMentions;
